import UIStrings from '@/Utils/UIStrings';

interface DialogCardRejectTitleProps {
    name: string;
}

function DialogCardRejectTitle({ name }: DialogCardRejectTitleProps) {
    return (
        <div className="text-foreground text-lg font-bold">{`${UIStrings.RejectApplicantDialogHeader1} ${name}`}</div>
    );
}

export default DialogCardRejectTitle;
